<template>
  <div class="kt-section__content animated fadeIn">
    <div class="pb-5 row">
      <button class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon" title="Regresar"
              v-on:click="$emit('regresar')">
        <i class="la la-arrow-left"></i>
      </button>
      <div class="col">
        <img :src="pasarela.logo" class="img-fluid" :alt="'logo '+pasarela.name">
      </div>
      <div class="col">

      </div>
    </div>
    <div class="pt-3 pb-5">
      <div class="pt-3">
        <h5 class="text-primary linea2">Datos del cliente:</h5>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Nombre</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt1 }} {{ persona.dt2 }} {{ persona.dt3 }} {{ persona.dt4 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Identificación</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt9 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Teléfono celular</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt20 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Correo electrónico</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt21 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Moneda</b>
          </div>
          <div class="col-md-8 col-12">
            {{ moneda.texto }}
          </div>
        </div>
      </div>
      <div class="pt-3">
        <h5 class="text-primary linea2">
          Datos de pago
        </h5>
        <div class="row">
          <div class="col-12 pb-2 pt-2 mb-3">
            <b-form-radio-group
                v-model="formulario.titular"
                name="tipo"
            >
              <b-form-radio :value="false">Pagar con datos del titular</b-form-radio>
              <b-form-radio :value="true">Pagar con datos de terceros</b-form-radio>
            </b-form-radio-group>
          </div>
        </div>
        <template v-if="formulario.titular">
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="form-group">
                <label><i class="fa fa-asterisk text-danger"></i>Tipo de documento de identidad</label>
                <combo-box v-model="formulario.tipo" :opciones="tipoDocumento" name="tipo de documento"
                           v-validate="{required:true,obj:true}"></combo-box>
                <span class="form-text text-danger">{{ errors.first('tipo de documento') }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="form-group">
                <label for="númerodd"><i class="fa fa-asterisk text-danger"></i>Número de documento</label>
                <input
                    type="tel"
                    class="form-control"
                    v-model="formulario.numero"
                    name="número de documento"
                    id="númerodd"
                    min="1" step="any"
                    v-validate="{decimal:2,required:true,min_value:1}"
                >
                <span class="form-text text-danger">{{ errors.first("número de documento") }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="form-group">
                <label for="apellidos"><i class="fa fa-asterisk text-danger"></i>Apellidos</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="formulario.apellido"
                    name="apellidos"
                    id="apellidos"
                    v-validate="{required:true,alpha_spaces:true}"
                >
                <span class="form-text text-danger">{{ errors.first("apellidos") }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="form-group">
                <label for="nombres"><i class="fa fa-asterisk text-danger"></i>Nombres</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="formulario.nombre"
                    name="nombres"
                    id="nombres"
                    v-validate="{required:true,alpha_spaces:true}"
                >
                <span class="form-text text-danger">{{ errors.first("nombres") }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="form-group">
                <label for="celular"><i class="fa fa-asterisk text-danger"></i>Celular</label>
                <input
                    type="tel"
                    class="form-control"
                    v-model="formulario.celular"
                    name="celular"
                    id="celular"
                    v-validate="{required:true,...valTelf.celular}"
                >
                <span class="form-text text-danger">{{ errors.first("celular") }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="form-group">
                <label for="email"><i class="fa fa-asterisk text-danger"></i>Email</label>
                <input
                    type="email"
                    class="form-control"
                    v-model="formulario.email"
                    name="email"
                    id="email"
                    v-validate="{required:true,email:true}"
                >
                <span class="form-text text-danger">{{ errors.first("email") }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="linea2 pt-4 pb-4"></div>
      <div class="pt-3">
        <h5 class="text-primary linea2">Últimos pagos realizados
          <button type="button" class="btn btn-outline-hover-success btn-sm btn-icon btn-circle"
                  v-on:click="consultaLista"><i class="flaticon-refresh"></i></button>
        </h5>
        <div class="table-responsive tabla-alto-scroll">
          <table class="table table-sm">
            <thead>
            <tr>
              <th>Referencia</th>
              <th>Fecha</th>
              <th class="text-right">Valor</th>
              <th class="text-center">Estado</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="cargando">
              <tr>
                <td colspan="5" class="text-muted text-center">
                  <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Cargando
                </td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(i,ii) in lista" :key="ii">
                <th scope="row">{{ i.dt2 }}</th>
                <td>{{ fechaLarga(i.ddt2) }}</td>
                <td class="text-right precio-syb">{{ punto(i.ndt2) }}</td>
                <td class="text-center">
                  <span class="badge" :class="colorStado(i)">{{ i.dt10 }}</span>
                </td>
              </tr>
              <tr v-if="lista.length===0">
                <td colspan="5" class="text-muted text-center">
                  No existen pagos
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="linea2 pt-4 pb-4"></div>
      <div class="mt-4 ">
        <form @submit.prevent="validar" class="row justify-content-center">
          <div class="col-7 text-center">
            Ingrese monto a pagar con tarjeta de crédito
          </div>
          <div class="col-md-8 col-12">
            <div class="kt-input-icon kt-input-icon--left">
              <input
                  type="number"
                  class="form-control form-control-lg danger"
                  name="valor"
                  id="valor"
                  v-model="formulario.valor"
                  v-validate="{required:true,decimal:2,max_value:maximo,min_value:0}"
                  min="1"
                  step="any"
                  :disabled="cargandoBtn"
                  ref="valor"
              />
              <span class="kt-input-icon__icon kt-input-icon__icon--left">
								<span><i class="la la-dollar "></i></span>
							</span>
            </div>
            <span class="form-text text-danger">{{ errors.first('valor') }}</span>
          </div>
          <div class="col-12 pt-4">
            <button type="submit" class="btn btn-pill btn-block btn-primary"
                    :class="cargandoBtn && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light'"
                    :disabled="cargandoBtn">Ir a Proceso de Pago
            </button>
          </div>
        </form>
      </div>
    </div>
    <form name="f3" id="f3" action="#" method="post" class="alignet-form-vpos2" v-if="procesado" v-show="false">
      <label for="acquirerId">acquirerId</label>
      <input class="form-control" id="acquirerId" name="acquirerId" :value="response.dt1">
      <label for="idCommerce">idCommerce</label>
      <input type="hidden" class="form-control" id="idCommerce" name="idCommerce" :value="response.dt2">
      <label for="purchaseOperationNumber">purchaseOperationNumber</label>
      <input class="form-control" id="purchaseOperationNumber" name="purchaseOperationNumber" :value="response.dt3">
      <label for="purchaseAmount">purchaseAmount</label>
      <input class="form-control" id="purchaseAmount" name="purchaseAmount" :value="response.dt4">
      <label for="acquirerId">purchaseCurrencyCode</label>
      <input class="form-control" id="purchaseCurrencyCode" name="purchaseCurrencyCode" :value="response.dt5">
      <label for="acquirerId">language</label>
      <input class="form-control" id="language" name="language" :value="response.dt6">
      <label for="acquirerId">shippingFirstName</label>
      <input class="form-control" id="shippingFirstName" name="shippingFirstName" :value="response.dt7">
      <label for="acquirerId">shippingLastName</label>
      <input class="form-control" id="shippingLastName" name="shippingLastName" :value="response.dt8">
      <label for="acquirerId">shippingEmail</label>
      <input class="form-control" id="shippingEmail" name="shippingEmail" :value="response.dt9">
      <label for="acquirerId">shippingAddress</label>
      <input class="form-control" id="shippingAddress" name="shippingAddress" :value="response.dt10">
      <label for="acquirerId">shippingZIP</label>
      <input class="form-control" id="shippingZIP" name="shippingZIP" :value="response.dt11">
      <label for="acquirerId">shippingCity</label>
      <input class="form-control" id="shippingCity" name="shippingCity" :value="response.dt12">
      <label for="acquirerId">shippingState</label>
      <input class="form-control" id="shippingState" name="shippingState" :value="response.dt13">
      <label for="acquirerId">shippingCountry</label>
      <input class="form-control" id="shippingCountry" name="shippingCountry" :value="response.dt14">
      <label for="userCommerce">userCommerce</label>
      <input class="form-control" id="userCommerce" name="userCommerce" :value="response.dt15">
      <label for="userCodePayme">userCodePayme</label>
      <input class="form-control" id="userCodePayme" name="userCodePayme" :value="response.dt16">
      <label for="descriptionProducts">descriptionProducts</label>
      <input class="form-control" id="descriptionProducts" name="descriptionProducts" :value="response.dt17">
      <label for="programmingLanguage">programmingLanguage</label>
      <input class="form-control" id="programmingLanguage" name="programmingLanguage" :value="response.dt18">
      <label for="purchaseVerification">purchaseVerification</label>
      <input class="form-control" id="purchaseVerification" name="purchaseVerification" :value="response.dt19">
      <label for="reserved1">reserved1</label>
      <input class="form-control" id="reserved1" name="reserved1" :value="response.dt20">
      <label for="reserved2">reserved2</label>
      <input class="form-control" id="reserved2" name="reserved2" :value="response.dt21">
      <label for="reserved3">reserved3</label>
      <input class="form-control" id="reserved3" name="reserved3" :value="response.dt22">
      <label for="reserved6">reserved6</label>
      <input class="form-control" id="reserved6" name="reserved6" :value="response.dt23">
      <label for="reserved9">reserved9</label>
      <input class="form-control" id="reserved9" name="reserved9" :value="response.dt24">
      <label for="reserved10">reserved10</label>
      <input class="form-control" id="reserved10" name="reserved10" :value="response.dt25">
    </form>
  </div>
</template>

<script>
import constantes from "../../../../constantes";
import comboBox from "@/componentes/comboBox";
import {persona, pagos, negociacion, catalogos} from "../../../../servicios";
import _ from 'lodash';

export default {
  name: "payme",
  props: {
    pasarela: {
      type: Object
    },
    persona: {
      type: Object,
      required: true,
    },
    tipo: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    lista: [],
    cargando: true,
    valor: null,
    cargandoBtn: false,
    alerta: false,
    response: {},
    procesado: false,
    formulario: {
      nombre: null,
      apellido: null,
      numero: null,
      tipo: {id: null},
      titular: false,
      valor: null
    },
    tipoDocumento: [],
    moneda: constantes.Constantes.enumeraciones.moneda,
    valTelf: constantes.Constantes.validacion,
  }),
  components: {
    comboBox
  },
  computed: {
    maximo: function () {
      return (this.$store.getters.getCotizacion.ndt13).toFixed(2);
    }
  },
  methods: {
    fechaLarga: (fechaIso) => constantes.funciones.formatoFechaL(fechaIso),
    punto: (n) => constantes.funciones.puntoMilesDecimal(n),
    colorStado: (obj) => constantes.funciones.colorEstado(obj.dt10),
    consultaLista: function () {
      pagos.actualizarEstados(this.pasarela).then(() => {
        pagos.consultaPagos(this.pasarela).then(r => r.data).then((lista) => {
          negociacion.busquedaId();
          this.lista = lista;
          this.cargando = false;
        });
      });
    },
    validar: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.cargandoBtn = true;
          this.enviarPago2();
        } else {
          this.$toast.show(`Completa el formulario`);
        }
      });
    },
    enviarPago2: _.debounce(function () {
      persona.validarDatos().then(r => r.data).then(validacion => {
        this.redirigir(validacion.bdt1);
      }).catch(() => {
        this.redirigir(false);
      });
    }, 2000),
    consultarTipoPersona: function () {
      catalogos.tipoDocumento().then((response) => {
        response.data.forEach(i=>{
          if(!i.bdt1){
            this.tipoDocumento.push(i);
          }
        })
      });
    },
    redirigir: function (tipo) {
      const cotizacion = this.$store.getters.getCotizacion;
      if (tipo) {
        this.enviarPago1();
      } else {
        this.$store.commit("setPago",
            {
              tipo: this.tipo,
              pasarela: this.pasarela,
              valor: this.formulario
            }
        );
        this.$toast.error(`Completa tu información personal primero`);
        this.$router.push({name: cotizacion.bdt4 ? 'compras.credito.solicitud' : 'compras.contado.licitud'});
      }
    },
    enviarPago1: function () {
      pagos.crearPago(this.formulario, this.pasarela, this.tipo).then(r => r.data).then(payme => {
        if (payme.bdt1) {
          this.response = payme;
          this.procesado = true;
          this.modalPayme();
        } else {
          this.$emit('regresar');
          this.$toast.error("Ha Ocurrido un error intenta mas tarde");
        }
      }).catch(() => {
        this.$emit('regresar');
      });
    },
    modalPayme: function () {
      const url = this.response.dt26;
      const id = "alignetsac";
      if (!document.getElementById(id)) {
        let script = document.createElement('script');
        script.setAttribute('src', url);
        script.setAttribute('id', id);
        document.head.appendChild(script);
        script.onload = () => {
          this.abrirModal();
        }
      }
    },
    abrirModal: function () {
      const parametro = this.response.dt27;
      // eslint-disable-next-line no-undef
      AlignetVPOS2.openModal(parametro, "3");
      setTimeout(() => {
        this.procesado = true;
        //this.response={};
      }, 500);
    },
    validarReducer: function() {

    }
  },
  mounted() {
    this.consultaLista();
    this.$refs.valor.focus();
  },
  created() {
    this.consultarTipoPersona();
  }
}
</script>
<style scoped>
.form-control-lg {
  text-align: center;
}

label {
  margin: 0;
}
</style>
